module.exports = __webpack_public_path__ + "media/images/ecalls/05_market_signs_side_details-0dd2a6eb0d5e223cda420a90c277905b.png";